export function triggerSuccess(): void {
  // No-op on web; haptics are not supported.
}
